import { useRef } from 'react';

const useArticleModalSwipeNavigation = ({ onNext, onPrev }) => {
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const handleSwipeStart = (event) => {
    touchStartX.current = event.touches[0].clientX;
    touchStartY.current = event.touches[0].clientY;
  };

  const handleSwipeEnd = (event) => {
    if (touchStartX.current === null || touchStartY.current === null) return;

    const deltaX = touchStartX.current - event.changedTouches[0].clientX;
    const deltaY = touchStartY.current - event.changedTouches[0].clientY;
    const swipeThreshold = 50;

    if (Math.abs(deltaX) > swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
      if (deltaX > 0 && onNext) {
        onNext();
      } else if (deltaX < 0 && onPrev) {
        onPrev();
      }
    }

    touchStartX.current = null;
    touchStartY.current = null;
  };

  return {
    handleSwipeEnd,
    handleSwipeStart
  };
};

export default useArticleModalSwipeNavigation;
